(function ($) {

    $(document).ready(function () {
        if (window.location.hash != '') {
            var hash = window.location.hash;
            if (hash.indexOf('omrwc')) {
                var reservation_hash_elements = '{' + hash.replace('#omrwc-', '') + '}';
                reservation_hash_elements = reservation_hash_elements.replace('client_id', '"client_id"');
                reservation_hash_elements = reservation_hash_elements.replace('tour_id', '"tour_id"');
                reservation_hash_elements = reservation_hash_elements.replace('room_id', '"room_id"');
                var json = jQuery.parseJSON(reservation_hash_elements);
                $('[data-target="#reservation"][data-tour-id="' + json['tour_id'] + '"][data-room-id="' + json['room_id'] + '"]').click();
                setTimeout(function () {
                    $('.search-client #client-id').val(json['client_id']);
                    $('.search-client #client-id').trigger('keyup');
                    window.location.hash = '';
                }, 2000)
            }
        }

        if($('#tour-table-ajax-load').length > 0){
            $.ajax({
                url: ajax_ajax_obj.ajaxurl,
                method: 'post',
                data: {
                    'action': 'load_ajax_tours',
                    'params': $('#ajax-params').val(),
                    'url': $('#ajax-url').val(),
                    'nonce': ajax_ajax_obj.nonce
                },
                beforeSend: function (data) {
                    $('#tour-table-ajax-load').html('<div class="center-loader"><img src="'+$('#tour-table-ajax-load').attr('data-loader')+'" /></div>');
                },
                success: function (data) {
                    $('#tour-table-ajax-load').html(data);
                    setTimeout(function(){
                        var table = jQuery('.auto-dt').DataTable({
                            "paging": false,
                            "lengthChange": false,
                            "searching": false,
                            "ordering": true,
                            "info": true,
                            "autoWidth": false,
                            "responsive": true,
                            "order": [[3, 'asc']],
                            // "order": [[ default_sort, default_sort_direction ]],
                            "language": {
                                "lengthMenu": "Pokaż _MENU_ rekordów na stronę",
                                "zeroRecords": "Wszystkie wyniki",
                                "info": "Strona _PAGE_ z _PAGES_",
                                "infoEmpty": "Brak",
                                "infoFiltered": "(filtered from _MAX_ total records)"
                            }
                        });
                    }, 3000)
                },
                error: function (errorThrown) {
                    console.log(errorThrown);
                }
            });
        }
    })

    $('#acf-field_657e9346954b0').on('change', function(){
        if($(this).val() == 'turnus rehabilitacyjny' || $(this).val() == 'turnus rehabilitacyjno-wypoczynkowy' || $(this).val() == 'turnus zdrowotny'){
            $('.acf-field-658600b63b98e input').val('500');
        }
        else{
            $('.acf-field-658600b63b98e input').val('400');
        }
    })

    if($('#acf-field_616b9da83c531').length > 0){
        $('#acf-field_616b9da83c531 option').each(function(){
            var txt = $(this).text();
            var arr = txt.split('|||');
            $(this).html(arr[0]);
            $(this).attr('data-type', arr[1]);
        })
    }

    $('#reservations-management, #reservation').on('hidden.bs.modal', function () {
        set_room_status_in_tour($(this).attr('data-tour-id'), $(this).attr('data-room-id'));
    });
    if ($('.tour-form .acf-field-64c24140db522').length > 0) {
        $('.table-responsive').insertBefore('.acf-form-submit');
        load_tour_rooms($('.rooms-table').attr('data-tour-id'));
    }

    $('#select-all-rooms').on('click', function () {
        var cprop = $(this).prop('checked');
        $(this).closest('table').find('.checked-room').prop('checked', cprop);
        $('.acf-field-64c24140db522 input[type="checkbox"]').prop('checked', cprop);
    });

    $('body').on('change', '.extension-price-toggle', function () {
        if ($(this).val() == 'tak') {
            $(this).closest('tr').find('.extension-price').show();
        } else {
            $(this).closest('tr').find('.extension-price').hide();
            $(this).closest('tr').find('.extension-price').val('');
        }
    });

    $('body').on('click', '.checked-room', function () {
        $('.acf-field-64c24140db522 input[value="' + $(this).val() + '"]').prop('checked', $(this).prop('checked'));
    });
    Inputmask("9{1,4},00", {placeholder: "99999"}).mask(".pricemask");

    $('.tour-table .reservation').on('click', function () {
        load_room_reservations_modal($(this).attr('data-tour-id'), $(this).attr('data-room-id'));
    });
    $('.tour-table .cancel').on('click', function () {
        load_room_reservations_modal($(this).attr('data-tour-id'), $(this).attr('data-room-id'));
    });
    $('.move-reservation-to-sell').on('submit', function (e) {
        e.preventDefault();
        bootbox.confirm({
            message: 'Czy na pewno chcesz przekształcić w sprzedaż?',
            buttons: {
                confirm: {
                    label: 'Tak',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Nie',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result === true) {
                    $.ajax({
                        url: ajax_ajax_obj.ajaxurl,
                        method: 'post',
                        data: {
                            'action': 'move_reservation_to_sell',
                            'source_reservations': $('.move-reservation-to-sell').find('#related-reservations').val(),
                            'nonce': ajax_ajax_obj.nonce
                        },
                        beforeSend: function (data) {

                        },
                        success: function (data) {
                            bootbox.alert('Rezerwacja zmieniona w sprzedaż', function () {
                                window.location.reload();
                            });
                        },
                        error: function (errorThrown) {
                            console.log(errorThrown);
                        }
                    });
                    console.log('ok')
                }
            }
        });
    })

    $('#reservation .search-client input').on('keyup', function () {
        if ($(this).attr('id') != 'client-id') {
            $('#client-id').val('');
        }
        var cname = $('#client-name').val();
        var csurname = $('#client-surname').val();
        var cbirthday = $('#client-birthday').val();
        var cid = $('#client-id').val();
        get_client_to_reservation(cname, csurname, cbirthday, cid);

    });

    $('body').on('click', '.add-client-reservation', function (e) {
        e.preventDefault();
        create_reservation($(this).attr('data-tour-id'), $(this).attr('data-room-id'), $(this).attr('data-client-id'));
        $(this).remove();
    });

    $('[data-target="#reservations-management"]').on('click', function () {
        reservation_management($(this).attr('data-tour-id'), $(this).attr('data-room-id'));
    });
    $('body').on('submit', '.reservation-cancel-form', function (e) {
        e.preventDefault();
        cancel_reservation($(this).find('[name="reservation_id"]').val(), $(this).find('textarea').val());
    });
    $('body').on('submit', '.set-reservation-expiration', function (e) {
        e.preventDefault();
        set_reservation_expiration($(this).find('[name="reservation_id"]').val(), $(this).find('[name="expiration"]').val());
    });

    $('[data-target="#add-client-modal"]').on('click', function () {
        $('.modal-add-client [name="modal-add-client"], .modal-add-client [name="modal-add-client-tour-id"], .modal-add-client [name="modal-add-client-room-id"]').remove();
        $('.modal-add-client').append('<input type="hidden" name="modal-add-client" value="1" />');
        $('.modal-add-client').append('<input type="hidden" name="modal-add-client-tour-id" value="' + $(this).attr('data-tour-id') + '" />');
        $('.modal-add-client').append('<input type="hidden" name="modal-add-client-room-id" value="' + $(this).attr('data-room-id') + '" />');

    })

    function set_reservation_expiration(reservation_id, expiration) {
        $.ajax({
            url: ajax_ajax_obj.ajaxurl,
            method: 'post',
            data: {
                'action': 'set_reservation_expiration',
                'reservation_id': reservation_id,
                'expiration': expiration,
                'nonce': ajax_ajax_obj.nonce
            },
            beforeSend: function (data) {

            },
            success: function (data) {
                bootbox.alert(data);
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function set_room_status_in_tour(tour_id, room_id) {
        $.ajax({
            url: ajax_ajax_obj.ajaxurl,
            method: 'post',
            data: {
                'action': 'set_room_status_in_tour',
                'tour_id': tour_id,
                'room_id': room_id,
                'nonce': ajax_ajax_obj.nonce
            },
            beforeSend: function (data) {

            },
            success: function (data) {
                window.location.reload();
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function cancel_reservation(reservation_id, reason) {
        bootbox.confirm({
            message: 'Czy na pewno chcesz anulować rezerwację?',
            buttons: {
                confirm: {
                    label: 'Tak',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Nie',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result === true) {
                    $('.move-reservation-to-sell').remove();
                    $.ajax({
                        url: ajax_ajax_obj.ajaxurl,
                        method: 'post',
                        data: {
                            'action': 'cancel_reservation',
                            'reservation_id': reservation_id,
                            'reason': reason,
                            'nonce': ajax_ajax_obj.nonce
                        },
                        beforeSend: function (data) {

                        },
                        success: function (data) {
                            if ($('#reservation' + reservation_id).length > 0) {
                                $('#reservation' + reservation_id).remove();
                            } else {
                                $('#reservation-history-' + reservation_id).find('.has-form').html('-');
                            }
                        },
                        error: function (errorThrown) {
                            console.log(errorThrown);
                        }
                    });
                }
            }
        });
        // if (confirm('Czy na pewno chcesz anulować rezerwację?')) {
        //
        // }
    }

    function reservation_management(tour_id, room_id) {
        $('#reservations-management').attr('data-room-id', room_id);
        $('#reservations-management').attr('data-tour-id', tour_id);
        $.ajax({
            url: ajax_ajax_obj.ajaxurl,
            method: 'post',
            data: {
                'action': 'reservation_management',
                'tour_id': tour_id,
                'room_id': room_id,
                'nonce': ajax_ajax_obj.nonce
            },
            beforeSend: function (data) {

            },
            success: function (data) {
                $('#reservations-container').html(data);

            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function create_reservation(tour_id, room_id, client_id) {
        $.ajax({
            url: ajax_ajax_obj.ajaxurl,
            method: 'post',
            data: {
                'action': 'create_reservation',
                'tour_id': tour_id,
                'room_id': room_id,
                'client_id': client_id,
                'nonce': ajax_ajax_obj.nonce
            },
            beforeSend: function (data) {
                $('.add-client-reservation').addClass('pointer-none');
            },
            success: function (data) {
                $('.add-client-reservation').removeClass('pointer-none');
                load_room_reservations_modal(tour_id, room_id);
                // $('.clients-list-container').html(data);
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function block_reservation_form(){
        $('.clients-list-container').addClass('block-reservations');
    }

    function get_client_to_reservation(cname, csurname, cbirthday, cid) {
        var room_id = $('#reservation').attr('data-room-id');
        var tour_id = $('#reservation').attr('data-tour-id');
        $.ajax({
            url: ajax_ajax_obj.ajaxurl,
            method: 'post',
            data: {
                'action': 'get_client_to_reservation',
                'tour_id': tour_id,
                'room_id': room_id,
                'cname': cname,
                'csurname': csurname,
                'cbirthday': cbirthday,
                'cid': cid,
                'nonce': ajax_ajax_obj.nonce
            },
            beforeSend: function (data) {
                $('.clients-list-container').html('<div class="clloader">' + $('.loader').html() + '</div>');
            },
            success: function (data) {
                $('.clients-list-container').html(data);
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function load_related_reservations(tour_id, room_id) {
        $.ajax({
            url: ajax_ajax_obj.ajaxurl,
            method: 'post',
            data: {
                'action': 'load_related_reservations',
                'tour_id': tour_id,
                'room_id': room_id,
                'nonce': ajax_ajax_obj.nonce
            },
            success: function (data) {
                $('.move-reservation-to-sell input').val(data);
                $('.move-reservation-to-sell').slideDown(400);
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function load_room_reservations_modal(tour_id, room_id) {
        $('#reservation').attr('data-room-id', room_id);
        $('#reservation').attr('data-tour-id', tour_id);
        $('.move-reservation-to-sell input').val('');
        $.ajax({
            url: ajax_ajax_obj.ajaxurl,
            method: 'post',
            data: {
                'action': 'load_room_reservations_modal',
                'tour_id': tour_id,
                'room_id': room_id,
                'nonce': ajax_ajax_obj.nonce
            },
            success: function (data) {
                var json = jQuery.parseJSON(data);
                if (json['free_places'] == 0) {
                    block_reservation_form();
                }
                if(json['can_sell'] == 1){
                    load_related_reservations(tour_id, room_id);
                }
                $('#reservation .places-info').html('Łączna liczba miejsc: ' + json['total_beds'] + ', liczba rezerwacji: ' + json['total_reservations'] + ', liczba wolnych miejsc: ' + json['free_places']);
                $('#reservation [data-target="#add-client-modal"]').attr('data-room-id', room_id);
                $('#reservation [data-target="#add-client-modal"]').attr('data-tour-id', tour_id);
                $('#reservation [data-target="#add-client-modal"]').slideDown(400);
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function load_tour_rooms(tour_id) {
        $.ajax({
            url: ajax_ajax_obj.ajaxurl,
            method: 'post',
            data: {
                'action': 'load_tour_rooms',
                'tour_id': tour_id,
                // 'pid': pid,
                // 'name': name,
                'nonce': ajax_ajax_obj.nonce
            },
            success: function (data) {
                $(".is-resizable").colResizable('destroy');
                var json = jQuery.parseJSON(data);
                $.each(json, function (key, data) {
                    $('.rooms-table table tbody').append('' +
                        '<tr>' +
                            '<td>' +
                                '<input class="checked-room" type="checkbox" value="' + key + '" name="roomid_' + key + '" ' + (data['used'] == 1 ? 'checked="checked"' : '') + ' />' +
                            '</td>' +
                        '<td>' + data['type'] + '</td>' +
                        '<td data-sort="'+data['number']+'">' + data['number'] + '</td>' +
                        '<td>' + data['floor'] + '</td>' +
                        '<td>' + data['side'] + '</td>' +
                        '<td data-sort="'+data['price']+'"><div class="has-suffix"><input class="pricemask" name="price_' + key + '" value="' + data['price'] + '" /><span>zł/os.</span></div></td>' +
                        '<td>' + (data['price_incomplete']!=-1?'<div class="has-suffix"><input class="pricemask" name="price_incomplete_' + key + '" value="' + data['price_incomplete'] + '" /><span>zł/os.</span></div>':'') + '</td>' +
                        '<td><select class="extension-price-toggle" name="extension_' + key + '"><option ' + (data['extension'] == 'nie' ? 'selected="selected"' : '') + '>nie</option><option ' + (data['extension'] == 'tak' ? 'selected="selected"' : '') + '>tak</option></select></td>' +
                        '<td><div class="has-suffix"><input class="pricemask extension-price" style="display: none" name="extension_price_' + key + '" value="' + data['extension_price'] + '" /><span>zł</span></div></td>' +
                        '</tr>')
                });
                Inputmask("9{1,4},00", {placeholder: "99999"}).mask(".pricemask");
                $('.extension-price-toggle').each(function () {
                    if ($(this).val() == 'tak') {
                        $(this).closest('tr').find('.extension-price').show();
                    }
                });
                $(".is-resizable").colResizable({
                    liveDrag: true,
                    partialRefresh: true,
                    resizeMode: 'flexible',
                    useLocalStorage: true,
                    postbackSafe: true,
                });
                setTimeout(function(){
                    var table = jQuery('.auto-dt2').DataTable({
                        "paging": false,
                        "lengthChange": false,
                        "searching": false,
                        "ordering": true,
                        "info": true,
                        "autoWidth": false,
                        "responsive": true,
                        "order": [[3, 'asc']],
                        // "order": [[ default_sort, default_sort_direction ]],
                        "language": {
                            "lengthMenu": "Pokaż _MENU_ rekordów na stronę",
                            "zeroRecords": "Wszystkie wyniki",
                            "info": "Strona _PAGE_ z _PAGES_",
                            "infoEmpty": "Brak",
                            "infoFiltered": "(filtered from _MAX_ total records)"
                        }
                    });
                }, 3000)

            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }


    $('.remove-tour').on('click', function (e) {
        e.preventDefault();
        var tid = $(this).attr('data-id');
        bootbox.confirm({
            message: 'Czy na pewno chcesz usunąć turnus? Spowoduje to usunięcie rezerwacji i sprzedaży jeśli istnieją.',
            buttons: {
                confirm: {
                    label: 'Tak',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Nie',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result === true) {
                    $.ajax({
                        url: ajax_ajax_obj.ajaxurl,
                        method: 'post',
                        data: {
                            'action': 'remove_tour',
                            'tid': tid,
                            'nonce': ajax_ajax_obj.nonce
                        },
                        beforeSend: function (data) {

                        },
                        success: function (data) {
                            console.log(data);
                            bootbox.alert('Turnus usunięty', function () {
                                window.location.reload();
                            });
                        },
                        error: function (errorThrown) {
                            console.log(errorThrown);
                        }
                    });
                    console.log('ok')
                }
            }
        });
    })
    $('.duplicate-tour').on('click', function (e) {
        e.preventDefault();
        var tour = $(this).attr('data-id');
        bootbox.confirm({
            message: 'Czy na pewno chcesz zduplikować turnus? Skopiowane zostaną tylko dane turnusu bez pokoi ani rezerwacji',
            buttons: {
                confirm: {
                    label: 'Tak',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Nie',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result === true) {
                    $.ajax({
                        url: ajax_ajax_obj.ajaxurl,
                        method: 'post',
                        data: {
                            'action': 'duplicate_tour',
                            'tour': tour,
                            'nonce': ajax_ajax_obj.nonce
                        },
                        beforeSend: function (data) {

                        },
                        success: function (data) {
                            bootbox.alert('Turnus powielony', function () {
                                window.location.reload();
                            });
                        },
                        error: function (errorThrown) {
                            console.log(errorThrown);
                        }
                    });
                    console.log('ok')
                }
            }
        });
    })

})(jQuery);